export const tryParseJSON = (jsonString: string): unknown => {
  try {
    const o: unknown = JSON.parse(jsonString);
    if (o) {
      return o;
    }
    return undefined;
  } catch {
    return undefined;
  }
};
